import React from 'react'
import Taiwan from './Taiwan'
import { DashboardSources } from '../../../../constants/DashboardConf'
import ChartHeader from '../ChartHeader'

function TaiwanMap (props) {
  const { data, settingMode, useFakeData } = props
  const { id, tableName, UISetting, content, categoryDetail } = data || {}

  const ifNoData = {}
  Object.keys(fakeStatistics).forEach(i => { ifNoData[i] = 0 })
  const formatMapData = data => {
    const total = data?.reduce((all, i) => all + (i.value || 0), 0)
    const addPercentage = data?.map(i => ({ ...i, percentage: Number((i.value / total * 100).toFixed(2)) }))
    const formatted = {}
    addPercentage?.sort((a, b) => b.percentage - a.percentage)?.forEach(i => { formatted[i?.label] = i?.percentage })
    return formatted
  }
  const useFake = useFakeData && categoryDetail === DashboardSources.THIRD_PARTY
  const mapData = settingMode || useFake ? fakeStatistics : (content?.data ? formatMapData(content?.data) : ifNoData)
  const mapValue = settingMode || useFake ? fakeValue : content?.data?.reduce((all, i) => ({ ...all, [i.label]: i.value }), {}) || {}

  const getOpacity = i => {
    if (i >= 15) return 0.2
    if (i >= 10) return 0.4
    if (i >= 5) return 0.7
    return 1
  }
  const rgbNumber = UISetting?.style?.themeColor?.replace('rgba(', '')?.replace('rgb(', '')?.replace(')', '')
  const mapColor = {}
  Object.keys(mapData).forEach((i, idx) => { mapColor[i] = rgbNumber ? `rgba(${rgbNumber}, ${getOpacity(idx)})` : 'rgba(0,0,0,0.2)' })

  return (
    <>
      <ChartHeader {...props} />
      <Taiwan
        idKey={`${tableName}_${id}`}
        statistics={mapData}
        valueObj={mapValue}
        areaColorSetting={mapColor}
        height="550px"
        afterFix="%"
      />
    </>
  )
}

export default TaiwanMap

const fakeStatistics = {
  台中市: 15.2984,
  高雄市: 13.7469,
  新北市: 13.9382,
  台北市: 11.09826,
  台南市: 10.111,
  桃園市: 9.838,
  彰化縣: 9.80,
  新竹市: 9.2036,
  雲林縣: 8.999,
  苗栗縣: 8.765,
  新竹縣: 7.89271,
  嘉義縣: 7.7493,
  南投縣: 6.5938,
  屏東縣: 6.2222,
  嘉義市: 5.325,
  基隆市: 5.13,
  宜蘭縣: 4.945,
  台東縣: 4.222,
  花蓮縣: 3.308,
  澎湖縣: 2.9756,
  金門縣: 1.478,
  連江縣: 0.7389
}

const fakeValue = {
  台中市: 1530,
  高雄市: 1375,
  新北市: 1394,
  台北市: 1110,
  台南市: 1011,
  桃園市: 984,
  彰化縣: 980,
  新竹市: 920,
  雲林縣: 900,
  苗栗縣: 877,
  新竹縣: 789,
  嘉義縣: 775,
  南投縣: 659,
  屏東縣: 622,
  嘉義市: 533,
  基隆市: 513,
  宜蘭縣: 495,
  台東縣: 422,
  花蓮縣: 331,
  澎湖縣: 298,
  金門縣: 148,
  連江縣: 74
}
